import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#898989"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 7.93934,
			y1: 16.4246,
			x2: 16.4246,
			y2: 7.93935,
			stroke: "white",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8.06066,
			y1: 7.93934,
			x2: 16.5459,
			y2: 16.4246,
			stroke: "white",
			strokeWidth: 3
		})
	]
});
export default SvgCloseButton;
